export const standardProductType = ['Business Check - Credit','ROC Search Report','Due Diligence Report','EWS','Portfolio Scrub','Compliance','Business Check - Competitor','Business Profile Report','Site Visit','Shipping Data','MCA Document Download','Business Check - Supplier','Business Check - International','TEV','Enhanced Due Diligence','KYC','LEI - Validation','LEI - Verification','Project - Fixed Cost','AR Management - Fixed','AR Management - Variable','Debt Collections','Skip & Trace','Legal Services','MDM','Data Projects','MSME','Project - Variable Cost','LEI - Commission','Commission','Resource Cost','ESG']

export const BUSINESS_CHECK_CREDIT='Business Check - Credit'
export const ROC_SEARCH_REPORT='ROC Search Report'
export const DUE_DILIGENCE_REPORT= "Due Diligence Report"
export const EWS='EWS'
// export const ESG='ESG'
export const PORTFOLIO_SCRUB='Portfolio Scrub'
export const COMPLIANCE='Compliance'
export const BUSINESS_CHECK_COMPETITOR='Business Check - Competitor'
export const BUSINESS_PROFILE_REPORT='Business Profile Report'
export const SITE_VISIT='Site Visit'
export const SHIPPING_DATA='Shipping Data'
export const MCA_DOCUMENT_DOWNLOAD = 'MCA Document Download'
export const BUSINESS_CHECK_SUPPLIER='Business Check - Supplier'
export const BUSINESS_CHECK_INTERNATIONAL='Business Check - International'
export const TEV='TEV'
export const MSME='MSME'
export const ENHANCED_DUE_DILIGENCE='Enhanced Due Diligence'
export const KYC='KYC'
export const LEI_VALIDATION='LEI - Validation'
export const LEI_VERIFICATION='LEI - Verification'
export const PROJECT_FIXED_COST='Project - Fixed Cost'
export const SKIP_TRACE='Skip & Trace'
export const LEGAL_SERVICES='Legal Services'
export const AR_MANAGEMENT_FIXED='AR Management - Fixed'
export const AR_MANAGEMENT_VARIABLE='AR Management - Variable'
export const DEBT_COLLECTIONS='Debt Collections'
export const MDM='MDM'
export const DATA_PROJECTS='Data Projects'

export const CDM_CUSTOMER='CDM - Customer'
export const CDM_SUPPLIER='CDM - Supplier'
export const CDM_INTERNATIONAL='CDM - International'
export const CDM_PROJECTS_EDD='CDM - Projects - EDD'
export const CDM_PROJECTS_TEV='CDM - Projects - TEV'
export const CDM_PROJECTS_MSME='CDM - MSME'
export const FI_KYC_SOLUTIONS='FI - KYC Solutions'
export const FI_LEI='FI - LEI'
export const FI_PROJECTS='FI - Projects'
export const B2B_AR_MANAGEMENT='B2B - AR Management'
export const B2B_DEBT_COLLECTIONS='B2B - Debt Collections'
export const B2B_PROJECTS='B2B - Projects'
export const PROJECTS_MDM='Projects - MDM'
export const PROJECTS_OTHERS='Projects - Others'
export const COMMISSION = 'Commission'
export const COMMISSION_SP = ['Commission']
export const ESG = ['ESG']

export const CREDIT_DECISIONING_AND_MONITORING_CDM='Credit Decisioning and Monitoring (CDM)'
export const FRAUD_AND_ID_SOLUTIONS_FI='Fraud and ID Solutions (FI)'
export const B2B_COLLECTIONS='B2B Collections'
export const PROJECTS='Projects'
export const SPCS = ['standardProduct','standardProductCategory','standardProductSegment']
export const PROJECT_VARIABLE_COST = 'Project - Variable Cost'
export const LEI_COMMISSION ='LEI - Commission'
export const RESOURCE_COST= 'Resource Cost'

export const spcsOptions ={
    "Projects":["Projects"],
    "B2B Collections":["B2B Collections"],
    "Fraud and ID Solutions (FI)":["Fraud and ID Solutions (FI)"],
    "Credit Decisioning and Monitoring (CDM)":["Credit Decisioning and Monitoring (CDM)"],
    "Projects - Others" :["Projects"],
    "Projects - MDM" :["Projects"],
    "B2B - Debt Collections" : ["B2B Collections"],
    "B2B - AR Management" : ["B2B Collections"],
    "B2B - Projects" : ["B2B Collections"],
    "FI - KYC Solutions":["Fraud and ID Solutions (FI)"],
    "FI - LEI":["Fraud and ID Solutions (FI)"],
    "FI - Projects":["Fraud and ID Solutions (FI)"],
    "CDM - Customer":["Credit Decisioning and Monitoring (CDM)"],
    "CDM - Supplier":["Credit Decisioning and Monitoring (CDM)"],
    "CDM - International":["Credit Decisioning and Monitoring (CDM)"],
    "CDM - Projects - EDD":["Credit Decisioning and Monitoring (CDM)"],
    "CDM - Projects - TEV":["Credit Decisioning and Monitoring (CDM)"],
    "CDM - MSME":["Credit Decisioning and Monitoring (CDM)"],
    "Business Check - Credit":["CDM - Customer"],
    "ROC Search Report":["CDM - Customer"],
    "Due Diligence Report":["CDM - Customer"],
    "EWS":["CDM - Customer"],
    "Portfolio Scrub":["CDM - Customer"],
    "Compliance":["CDM - Customer"],
    "Business Check - Competitor":["CDM - Customer"],
    "Business Profile Report":["CDM - Customer"],
    "Site Visit":["CDM - Customer"],
    "Shipping Data":["CDM - Customer"],
    "MCA Document Download":["CDM - Customer"],
    "Business Check - Supplier":["CDM - Supplier"],
    "Business Check - International":["CDM - International"],
    "TEV":["CDM - Projects - TEV"],
    "Enhanced Due Diligence":["CDM - Projects - EDD"],
    "KYC":["FI - KYC Solutions"],
    "LEI - Validation":["FI - LEI"],
    "LEI - Verification":["FI - LEI"],
    "Project - Fixed Cost":["FI - Projects"],
    "AR Management - Variable":["B2B - AR Management"],
    "AR Management - Fixed":["B2B - AR Management"],
    "Debt Collections":["B2B - Debt Collections"],
    "Skip & Trace":["B2B - Projects"],
    "Legal Services":["B2B - Projects"],
    "MDM":["Projects - MDM"],
    "MSME":["CDM - MSME"],
    "Data Projects":["Projects - Others"],
    "Project - Variable Cost":["FI - Projects"],
    "LEI - Commission":["FI - LEI"],
    "Commission":["Referral"],
    "Resource Cost":["Projects - Others"],
    "ESG":["ESG"]
}